import { MultiSelectRemote } from "components/Form"
import { useMemo } from "react"
import { FormatterCell, RemoteOptionsColumnModel } from "../../models"
import { GenericFilterModelCollection, IdNameResponseItemsResponseModel } from "services/tenantManagementService"

type Props = {
	column: RemoteOptionsColumnModel<any>
	value: number[] | undefined
	onChange(value: number[] | undefined): void
	onBlur(): void
	loading: boolean
	formatterCell: FormatterCell
}

export const RemoteOptionsEditableCell = ({ column, value, onChange, onBlur, loading, formatterCell }: Props) => {
	const specificPropsMemo = useMemo(
		() => {
			const { items, getItemText, getItemStyle, getText, filters } = column;

			return {
				getItemText,
				getItemStyle,
				getText,
				entityPrefix: column.entityPrefix,
				fetchItemsFunction: async (genericFilter: GenericFilterModelCollection, searchValue: string | undefined) => {
					return await column.fetchItemsFunction(genericFilter, searchValue, formatterCell);
				},
				fetchSelectedItemsFunction: (ids: number[]) => {
					const selectedItems = ids.map((id) => items.find((item) => item.id === id))
					const model = new IdNameResponseItemsResponseModel({
						success: true,
						items: selectedItems
					});
					return Promise.resolve(model);
				},
				filters: filters
			}
		},
		[column, formatterCell]
	)

	return (
		<MultiSelectRemote
			value={value}
			onChange={onChange}
			onBlur={onBlur}
			{...specificPropsMemo}
			size='small'
		/>
	)
}
